module.exports = __webpack_public_path__ + "static/media/image2.9fa4a758.svg";